<template>
  <div>
    <Breadcrumb mainTitle="Sensor Data"
      breadContent="This page shows a mock up of how the sensor data display chart will look" subTitle="Sensor Data" />
    <div v-if="isLoggedIn">
      <div class="container mx-auto px-4 mt-4">
        <MapChart />
        <div class="charts-section">
          <!-- Regular Charts Section -->
          <h2 class="text-4xl font-bold mb-6 ">Indoor Single Data Source Charts</h2>
          <div class="charts-grid">
            <div v-for="(chart, index) in regularCharts" :key="index" class="chart-card">
              <div class="chart-card-header">
                <h3 class="text-lg font-semibold">{{ chart.title }}</h3>
              </div>
              <ChartComponent :chartType="chart.type" class="chart-card-body" />
            </div>
          </div>

          <!-- Delta Charts Section -->
          <h2 class="text-4xl font-bold mt-6 mb-6">Delta Charts</h2>
          <div class="charts-grid">
            <div v-for="(chart, index) in deltaCharts" :key="index" class="chart-card">
              <div class="chart-card-header">
                <h3 class="text-lg font-semibold">{{ chart.title }}</h3>
              </div>
              <ChartComponent :chartType="chart.type" class="chart-card-body" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div>Not Logged in</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Breadcrumb from '@/components/Breadcrumb.vue'
import SelectCharts from '@/components/SelectCharts.vue'
import ChartComponent from '@/components/ChartComponent.vue'
import MapChart from '@/components/MapChart'

import Session, { doesSessionExist } from 'supertokens-web-js/recipe/session';


export default {
  name: 'SensorData',
  components: {
    Breadcrumb,
    MapChart,
    ChartComponent
  },
  data() {
    return {
      isLoggedIn: null,
      regularCharts: [
        { type: 'co2', title: 'CO2 Levels' },
        { type: 'temperature', title: 'Temperature' },
        { type: 'humidity', title: 'Humidity' },
        { type: 'pressure', title: 'Pressure' },
      ],
      deltaCharts: [
        { type: 'delta_co2', title: 'Delta CO2 Levels' },
        { type: 'delta_temperature', title: 'Delta Temperature' },
        { type: 'delta_humidity', title: 'Delta Humidity' },
        { type: 'delta_pressure', title: 'Delta Pressure' }
      ]

    }
  },
  async mounted() {
    window.scrollTo(0, 0);
    try {
      let fetchedFaqData = await axios.get("/assets/data/faq.json");
      this.faqs = fetchedFaqData.data.faqs;
    } catch (error) {
      console.error("Failed to fetch FAQ data:", error);
    }
    if (await Session.doesSessionExist()) {
      // user is logged in
      console.log("logged in");
      this.isLoggedIn = true;

    } else {
      // user has not logged in yet
      console.log("no login yet");
      this.isLoggedIn = false;
    }
  }
}
</script>

<style scoped>
.charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 20px;
  justify-items: center;
}

.chart-card {
  background-color: #f9fafb;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  width: 100%;
  max-width: 600px;
  transition: transform 0.3s ease;
}

.chart-card:hover {
  transform: scale(1.02);
}

.chart-card-header {
  background-color: #f3f4f6;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
}

.chart-card-body {
  padding: 16px;
}
</style>